import { render } from "./BoxPrintClose.vue?vue&type=template&id=2ac8929e"
import script from "./BoxPrintClose.vue?vue&type=script&lang=js"
export * from "./BoxPrintClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__